import { applyMiddleware, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';

import { rootReducerWrapper } from './rootReducer';

const initialState = {};

const middleware = [thunk];

const store = createStore(
  rootReducerWrapper,
  initialState,
  compose(applyMiddleware(...middleware))
);

export default store;
